export const platformEmotions = [
  {
    label: "LOL (😂 Laugh Out Loud)",
    value: "lol",
    description:
      "Make the reader genuinely laugh or feel amused - great for showing personality and being relatable",
  },
  {
    label: "WTF (🤯 Mind-Blown)",
    value: "wtf",
    description:
      "Share counter-intuitive insights or surprising data that challenges common beliefs",
  },
  {
    label: "OMG (✨ Incredible)",
    value: "omg",
    description:
      "Deliver an incredible revelation or insight that makes followers rethink their assumptions",
  },
  {
    label: "AWW (💝 Heartwarming)",
    value: "aww",
    description:
      "Share vulnerable moments or wins that create emotional connection with followers",
  },
  {
    label: "WOW (🚀 Impressive)",
    value: "wow",
    description:
      "Share achievements or insights that position you as an expert",
  },
  {
    label: "AHA (💡 Educational)",
    value: "aha",
    description:
      "Provide clear, actionable insights that make complex topics simple to understand",
  },
  {
    label: "FOMO (⚡ Must-Have)",
    value: "fomo",
    description:
      "Create urgency and exclusivity around your insights or offerings",
  },
  {
    label: "TRUST (🤝 Credible)",
    value: "trust",
    description:
      "Share experiences and lessons that demonstrate expertise and authenticity",
  },
  {
    label: "HOPE (✨ Inspiring)",
    value: "hope",
    description:
      "Motivate followers by sharing possibilities and positive outcomes",
  },
  {
    label: "RELIEF (🎯 Solution)",
    value: "relief",
    description: "Address common pain points with clear, practical solutions",
  },
];
